/**
* @prop --uic-charts-data-group-color: color of a specific data group, set it inside of the datagroups css class.
* @prop --uic-charts-bar-chart-general-font-size: bar chart base text font size
* @prop --uic-charts-bar-chart-text-color: bar chart text color (labels, tooltip etc.)
* @prop --uic-charts-bar-chart-x-axis-label-font-weight: x axis label font weight
* @prop --uic-charts-bar-chart-x-axis-label-font-size: x axis label font size
* @prop --uic-charts-bar-chart-tick-line-color: color of tick lines
* @prop --uic-charts-bar-chart-y-axis-tick-font-weight: y axis tick label font weight
* @prop --uic-charts-bar-chart-y-axis-tick-font-size: y axis tick label font size
* @prop --uic-charts-bar-chart-y-axis-label-font-weight: y axis label font weight
* @prop --uic-charts-bar-chart-y-axis-label-font-size: x axis label font size
* @prop --uic-charts-bar-chart-in-bar-label-font-size: font size for text within the bars
* @prop --uic-charts-bar-chart-in-bar-label-font-weight: font weight for text within the bars
* @prop --uic-charts-bar-chart-loading-overlay-color: color of the loading overlay
* @prop --uic-charts-bar-chart-target-value-stroke-color: color of the target value lines
* @prop --uic-charts-bar-chart-target-value-stroke-dasharray: dasharray of the target value lines
* @prop --uic-charts-bar-chart-target-value-filter: css svg filter of the target values, drop-shadow by default
* @prop --uic-charts-bar-chart-target-value-stroke-width: stroke width of the target value lines
*/

.uic-bar-chart {
    font-size: var(--uic-charts-bar-chart-general-font-size, 0.8rem);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: var(--uic-charts-bar-chart-text-color, black);

    &__x-axis .tick line {
        display: none;
    }

    &__x-axis text {
        font-weight: var(--uic-charts-bar-chart-x-axis-label-font-weight, bold);
        font-size: var(--uic-charts-bar-chart-x-axis-label-font-size, 0.8rem);
    }

    &__y-axis path {
        display: none;
    }

    &__y-axis-grid-line {
        stroke: var(--uic-charts-bar-chart-tick-line-color, #eee);
    }

    &__y-axis-grid-line--zero {
        stroke: var(--uic-charts-bar-chart-tick-line-zero-color, #363636);
        stroke-dasharray: var(
            --uic-charts-bar-chart-tick-line-zero-dash-array,
            2
        );
    }

    &__y-axis text {
        font-weight: var(
            --uic-charts-bar-chart-y-axis-tick-font-weight,
            normal
        );
        font-size: var(--uic-charts-bar-chart-y-axis-tick-font-size, 0.8rem);
    }

    &__y-axis-label {
        font-weight: var(
            --uic-charts-bar-chart-y-axis-label-font-weight,
            normal
        );
        font-size: var(--uic-charts-bar-chart-y-axis-label-font-size, 0.8rem);
    }

    &__target-value {
        stroke: var(--uic-charts-bar-chart-target-value-stroke-color, white);
        stroke-dasharray: var(
            --uic-charts-bar-chart-target-value-stroke-dasharray,
            5,
            3
        );
        filter: var(
            --uic-charts-bar-chart-target-value-filter,
            drop-shadow(1px 1px 2px rgba(0, 0, 0, 2.7))
        );
        stroke-width: var(--uic-charts-bar-chart-target-value-stroke-width, 2);
    }

    &__datagroup {
        fill: var(--uic-charts-data-group-color, black);
    }

    &__tooltip-color-indicator {
        width: 1em;
        height: 1em;
        margin: 0 0.5em 0 0;
        display: inline-block;
        vertical-align: middle;
        background-color: var(--uic-charts-data-group-color, black);
    }

    &__in-bar-label {
        font-size: var(--uic-charts-bar-chart-in-bar-label-font-size, 0.625rem);
        font-weight: var(--uic-charts-bar-chart-in-bar-label-font-weight, bold);
    }

    &__loading_indicator {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
        text-align: center;
        vertical-align: middle;

        background: var(--uic-charts-bar-chart-loading-overlay-color, white);
    }

    uic-loader {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: max(188px, 25%);
        text-align: center;
        vertical-align: middle;
    }

    &__no-data-indicator {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 100%;
    }
}
